// Packages
import PropTypes from 'prop-types'

// Components
import PurchaseOrderItemForm from 'modules/PurchaseOrderItems/components/Form';

// Other
import useApi from 'hooks/useApi';

const PurchaseOrderItemCreateScreen = ({ onClose, onSubmit, purchaseOrderId, supplier_id }) => {

    const { post: createItem, errors } = useApi('/purchaseorderitems',  false)

	const submit = async (values) => {

        if( await createItem({purchase_order_id: purchaseOrderId, ...values}, 'Purchase order item created!') ) {
    
            onSubmit();
        }
    }


    return(
        <PurchaseOrderItemForm 
            errors={errors} 
            onClose={onClose} 
            onSubmit={submit} 
            supplier_id={supplier_id}
            type='create' 
        />
    )
}

PurchaseOrderItemCreateScreen.propTypes = {
	onClose: PropTypes.func,
	onSubmit: PropTypes.func,
    purchaseOrderId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    supplier_id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
}

PurchaseOrderItemCreateScreen.defaultProps = {
	onClose: () => {alert('onClose is not set!')},
    onSubmit: () => {alert('onSubmit is not set!')},
    purchaseOrderId: null,
    supplier_id: '',
}

export default PurchaseOrderItemCreateScreen;